import React from "react";
import clsx from "clsx";

import AppBox from "@/components/AppBox";
import AppIcon from "@/components/AppIcon";
import AppText from "@/components/AppText"

interface AppSwitchProps {
  onChange: (checked: boolean) => void;
  checked: boolean;
  label?: string;
  labelPosition?: "left" | "right";
  disabled?: boolean;
  className?: string;
}

const AppSwitch: React.FC<AppSwitchProps> = ({
  onChange,
  checked,
  label,
  labelPosition = "left",
  disabled = false,
  className = "",
}) => {
  return (
    <AppBox
      align="center"
      gap={2}
      className={clsx(
        "inline-flex",
        {"flex-row-reverse justify-end": labelPosition === 'right'},
        className
      )}
    >
      {label && (
        <AppText variant="label">
          {label}
        </AppText>
      )}
      <button
        onClick={() => !disabled && onChange(!checked)}
        disabled={disabled}
        className={clsx(
          "relative inline-flex min-w-[44px] items-center h-6 w-11 rounded-full transition-colors focus:outline-none",
          checked
            ? "bg-primary hover:bg-primary-hover"
            : disabled ? "bg-gray-200" : "bg-darkGray dark:bg-gray-400 hover:bg-darkGray-hover"
        )}
      >
        <span
          className={clsx(
            "absolute flex h-5 w-5 items-center justify-center rounded-full shadow-md transition-transform",
            checked ? "translate-x-5" : "translate-x-1",
            disabled ? "bg-gray-100" : "bg-white"
          )}
        >
          {checked ? (
            <AppIcon name="check" size="sm" className="text-primary" />
          ) : (
            <AppIcon name="x" size="sm" className={disabled ? "text-gray-300" : "text-gray-400"} />
          )}
        </span>
      </button>
    </AppBox>
  );
};

export default AppSwitch;